import React, { Component } from 'react';  
import { hashHistory } from 'react-router';
import { 
	getFundLabel,
	fundLabel,
	fundListGm,
	fundListSm,
	fundListJh,
	fundListZh,
	getFundListByPublic,
	getFundListByPrivate,
	getFundListByAccount,
	getFundListByBroker,
	productListType
} from '../action/productAction.js';
import { connect } from 'react-redux';

class ChannelNav extends Component {
	state = {
		toggleFlag: "none"
	}

    componentWillMount() {
        
    }

    toggleModel = () => {
    	this.setState({
    		toggleFlag: this.state.toggleFlag != "none" ? "none" : "block" 
    	});
    }
	dqlc(){
	    hashHistory.push({
	      pathname: '/InvestmentPlan',
	      state: {
	      }
	    });
	}
	home(){
		hashHistory.push({
	      pathname: '/nullView',
	    });
	}
	wdtz(){
		hashHistory.push({
	      pathname: '/MyInvestFund',
	      state: {
	      }
	    });
	}

	//初始化产品数据
	initProductList = (typeNum, typeName) => {
		this.props.dispatch(fundLabel(null));
		this.props.dispatch(fundListGm(null));
		this.props.dispatch(fundListSm(null));
		this.props.dispatch(fundListZh(null));
		this.props.dispatch(fundListJh(null));
		if(typeName == "专户计划") {
			this.props.dispatch(getFundLabel({fund_type: typeNum}, "Z", this));
		}else {
			this.props.dispatch(getFundLabel({fund_type: typeNum}, "", this));
		}
		this.props._this.setState({
			productValue: typeName,
			labelText: "全部",
			sortValue: "按涨跌幅排序",
			sortValue2: "按万份收益排序",
			sortValue3: "日涨跌幅",
			toggle: false,
			chooseType: "不限",
			chooseType1: "不限",
			chooseType2: "不限",
			chooseType3: "不限",
			chooseType4: "不限",
			chooseTag: "",
			chooseTag1: "",
			chooseTag2: "",
			chooseTag3: "",
			chooseTag4: "",
			startMoney: "起投金额",
			dateFinish: "投资期限"
		});
		this.props.dispatch(productListType(typeName));
	}

    goPublic = () => {
    	this.setState({
			toggleFlag: "none"
		});
    	if(hashHistory.getCurrentLocation().pathname == "/offeringList") {
	    	if(this.props.productListType != "优选公募") {
	    		this.initProductList("G", "优选公募");
	    	}
	    }else {
	    	this.props.dispatch(productListType("优选公募"));
		    hashHistory.push({
		      pathname: '/offeringList'
		    });
	    }
    }

    goPrivate = () => {
    	this.setState({
			toggleFlag: "none"
		});
    	if(this.props.isLogin) {
    		if(hashHistory.getCurrentLocation().pathname == "/offeringList") {
	    		if(this.props.productListType != "明星私募") {
		    		this.initProductList("S", "明星私募");
		    	}
		    }else {
		    	this.props.dispatch(productListType("明星私募"));
			    hashHistory.push({
			      pathname: '/offeringList'
			    });
		    }
    	}else {
    		hashHistory.push({
	    		pathname: "/Login",
	    		state: {
	    			callback: () => {
	    				if(hashHistory.getCurrentLocation().pathname == "/offeringList") {
				    		if(this.props.productListType != "明星私募") {
					    		this.initProductList("S", "明星私募");
					    	}
					    }else {
					    	this.props.dispatch(productListType("明星私募"));
						    hashHistory.push({
						      pathname: '/offeringList'
						    });
					    }
	    			},
	    			route: window.history.length
	    		}
	    	});
    	}
    }

    goSpec = () => {
    	this.setState({
			toggleFlag: "none"
		});
    	if(this.props.isLogin) {
    		if(hashHistory.getCurrentLocation().pathname == "/offeringList") {
	    		if(this.props.productListType != "专户计划") {
		    		this.initProductList("J", "专户计划");
		    	}
		    }else {
		    	this.props.dispatch(productListType("专户计划"));
			    hashHistory.push({
			      pathname: '/offeringList'
			    });
		    }
    	}else {
    		hashHistory.push({
	    		pathname: "/Login",
	    		state: {
	    			callback: () => {
	    				if(hashHistory.getCurrentLocation().pathname == "/offeringList") {
				    		if(this.props.productListType != "专户计划") {
					    		this.initProductList("J", "专户计划");
					    	}
					    }else {
					    	this.props.dispatch(productListType("专户计划"));
						    hashHistory.push({
						      pathname: '/offeringList'
						    });
					    }
	    			},
	    			route: window.history.length
	    		}
	    	});
    	}
    }

    goBroker = () => {
    	this.setState({
			toggleFlag: "none"
		});
    	if(this.props.isLogin) {
    		if(hashHistory.getCurrentLocation().pathname == "/offeringList") {
	    		if(this.props.productListType != "券商集合") {
		    		this.initProductList("J", "券商集合");
		    	}
		    }else {
		    	this.props.dispatch(productListType("券商集合"));
			    hashHistory.push({
			      pathname: '/offeringList'
			    });
		    }
    	}else {
    		hashHistory.push({
	    		pathname: "/Login",
	    		state: {
	    			callback: () => {
	    				if(hashHistory.getCurrentLocation().pathname == "/offeringList") {
				    		if(this.props.productListType != "券商集合") {
					    		this.initProductList("J", "券商集合");
					    	}
					    }else {
					    	this.props.dispatch(productListType("券商集合"));
						    hashHistory.push({
						      pathname: '/offeringList'
						    });
					    }
	    			},
	    			route: window.history.length
	    		}
	    	});
    	}
    }

    goMySelf = () => {
    	this.setState({
			toggleFlag: "none"
		});
    	if(this.props.isLogin) {
	    	if(hashHistory.getCurrentLocation().pathname != "/mySelfList"){
	    		hashHistory.push({
		    		pathname: "/mySelfList"
		    	})
	    	}
	    }else {
	    	hashHistory.push({
	    		pathname: "/Login",
	    		state: {
	    			route: window.history.length,
	    			callback: () => {
	    				if(hashHistory.getCurrentLocation().pathname != "/mySelfList"){
				    		hashHistory.push({
					    		pathname: "/mySelfList"
					    	})
				    	}
	    			}
	    		}
	    	})
	    }
    }

    goAssets = () => {
    	this.setState({
			toggleFlag: "none"
		});
    	if(this.props.isLogin) {
    		if(hashHistory.getCurrentLocation().pathname != "/myAssets"){
	    		hashHistory.push({
		    		pathname: "/myAssets"
		    	});
	    	}
    	}else {
    		hashHistory.push({
	    		pathname: "/Login",
	    		state: {
	    			route: window.history.length,
	    			callback: () => {
	    				if(hashHistory.getCurrentLocation().pathname != "/myAssets"){
				    		hashHistory.push({
					    		pathname: "/myAssets"
					    	});
				    	}
	    			}
	    		}
	    	})
    	}

    }

    render() {
        return (
            <div style={{position: "relative", width: 30, height: 30}}>
	         	<span onClick={this.toggleModel} style={{width: 30, height: 30, background: "#fff", position: "absolute", left: 0, top: 0}}></span>
	        	<div style={{display: this.state.toggleFlag, width: window.winWidth, height: window.winHeight - 44, position: "fixed", top: 44, left: 0, background: "rgba(0, 0, 0, 0.2)", zIndex: 10}}>
	        		<div style={{height: 330, background: "#fff", color: "#000"}}>
	        			<div style={{height: 40, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", paddingLeft: 13}}>频道导航</div>
	        			<div style={{height: 60, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row"}}>
	        				<div onClick={this.home} style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd"}}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}} ></span>首页</div>
	        				<div onClick={this.goAssets} style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%"}}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>个人中心</div>
	        			</div>
	        			<div style={{height: 50, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row"}}>
	        				<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd"}} onClick={this.goPublic}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>优选公募</div>
	        				<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd"}} onClick={this.goPrivate}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>明星私募</div>
	        				<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%"}} onClick={this.goSpec}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>专户计划</div>
	        			</div>
	        			<div style={{height: 50, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row"}}>
	        				<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd"}} onClick={this.goBroker}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>券商集合</div>
	        				<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd"}}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>零钱理财</div>
	        				<div onClick={this.dqlc} style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%"}}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}} ></span>定期理财</div>
	        			</div>
	        			<div style={{height: 50, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row"}}>
	        				<div onClick={this.wdtz} style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd"}}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>我的投资</div>
	        				<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd"}} onClick={this.goMySelf}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>自选<span style={{color: "transparent"}}>自选</span></div>
	        				<div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%"}}><span style={{width: 15, height: 15, background: "#000", display: "block", marginRight: 5}}></span>交易查询</div>
	        			</div>
	        			<div style={{height: 80, WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row"}}>
	        				
	        			</div>
	        		</div>
	        	</div>
	        </div>
		)
    }
} 

function mapStateToProps(state,ownProps) {
  return {
    fundLabel: state.fundLabel,
    fundListGm: state.fundListGm,
    fundListSm: state.fundListSm,
    fundListJh: state.fundListJh,
    fundListZh: state.fundListZh,
    isLogin: state.isLogin,
    productListType: state.productListType
  }
}

export default connect(mapStateToProps)(ChannelNav);


// WEBPACK FOOTER //
// ./src/components/ChannelNav.js